import { render } from "./Invoice.vue?vue&type=template&id=3ea96f46&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=3ea96f46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ea96f46"

export default script